<!--
 * @Descripttion: 
 * @version: 
 * @Author: jing
 * @Date: 2021-03-22 19:58:11
 * @LastEditors: jing
 * @LastEditTime: 2021-08-05 00:07:14
-->
<template>
  <div class="tabbar12">
    <div
      v-for="(item, index) in btns"
      class="tabbar_item"
      @click="clickItem(item, index)"
      :class="item.class"
      :style="item.style"
      :key="item.name"
    >
      <div :class="[{ active: item.isActive }, 'icon-item']">
        <div
          class="item-bg"
          :style="[{ backgroundColor: item.isActive ? cardcoulor : '#fff' }]"
        >
          <img v-if="item.btn_img" :src="item.btn_img" class="btn_img" />
          <span
            v-html="item.default_font"
            v-else-if="item.default_font"
            class="icon iconfont"
            style="color:#000"
          ></span>
          <img v-else :src="item.default_img" class="btn_img" />
        </div>
      </div>
      <span
        :class="[{ 'text-active': item.isActive }, 'text']"
        :style="[{ color: item.isActive ? cardcoulor : '#000' }]"
        >{{ item.name }}</span
      >
    </div>
  </div>
</template>
<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
// import createimg from "@/utils/createimg";
export default {
  components: {},
  props: {
    seleIndex: {
      type: Number,
      default: 0
    },
    btns: {
      type: Array,
      default: () => []
    },
    cardcoulor: {
      type: String,
      default: () => "#f56719"
    }
  },
  data() {
    return {
      myw: "20%",
      //底部导航
      navData: [
        {
          name: "抽奖",
          pagename: "prize",
          click: "clickPrize",
          ico:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/prize.png",
          no:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/prize.png",
          yes:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/prize-active.png",
          isActive: false
        },
        {
          name: "导航",
          pagename: "nav",
          click: "clickNav",
          ico:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/nava.png",
          no:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/nava.png",
          yes:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/nava-active.png",
          isActive: false
        },
        {
          name: "报名",
          pagename: "signup",
          click: "clickSignup",
          ico:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/bm.png",
          no:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/bm.png",
          yes:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/bm-active.png",
          isActive: false
        },
        {
          name: "咨询",
          pagename: "consult",
          click: "clickConsult",
          ico:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/zx.png",
          no:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/zx.png",
          yes:
            "http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard4/zx-active.png",
          isActive: false
        }
      ],
      showImg2: {
        isShow: false,
        url: "",
        width: "",
        intro: ""
      },
      isShowHdkShare: false, //是否显示小程序分享
      isShowShareGuide: false, //是否显示网页分享
      isShowSaveAddressList: false, //是否显示存通讯录
      imgUrlCardPoster: ""
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo"
    ]),
    evenNavData: function() {
      return this.navData.filter(function(item, i) {
        return item.isHide != true;
      });
    }
  },
  methods: {
    clickItem(item, index) {
      console.log("index", index);
      this.$emit("clickTabbar", item, index);
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}
/* 底部导航 */
.tabbar12 {
  width: 100%;
  height: 60px;
  background: #fff;
  position: fixed;
  bottom: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 12;
  border-top: 1px solid #dcdfe6;
}

.tabbar_item {
  position: relative;
  text-align: center;
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  flex-direction: column;
  width: 25%;
}
.icon-item{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -11px;
  width: 55px;
  height: 55px;
  margin: 0;
  box-sizing: border-box;
  padding: 11px;
  border-radius: 50%;
  background-color:none;
}
.item-bg{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  // background-color: #fff !important;
  // color: #fff !important;
  // box-shadow: 0 0 5px #fff !important;
}

.active {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -11px;
  width: 55px;
  height: 55px;
  margin: 0;
  box-sizing: border-box;
  padding: 11px;
  border-radius: 50%;
  background-color: #fff;
}


 .icon-item.active .item-bg {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  // background-color: #F56719 !important;
  color: #fff !important;
  // box-shadow: 0 0 5px #F56719 !important;
}

.text {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 35px;
  width: 100%;
  color: #000;
  font-size: p2r(24px);
}
.text-active{
  // color: #f66719;
  margin-top: 2px;
}

.btn_img{
  width: 20px;
  height: 20px;
}

/* .tabbar_text {
  padding-top: 5px;
  display: inline-block;
  font-size: 12px;
  color: #000000;
} */
.tabbar_item_chat {
}
.tabbar_item_chat img {
  width: 60px;
  height: 60px;
  margin-top: -30px;
}
</style>
